/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupquestionlabel2Inputs */

const en_signupquestionlabel2 = /** @type {(inputs: Signupquestionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const de_signupquestionlabel2 = /** @type {(inputs: Signupquestionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage`)
};

/**
* | output |
* | --- |
* | "Question" |
*
* @param {Signupquestionlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupquestionlabel2 = /** @type {((inputs?: Signupquestionlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupquestionlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupquestionlabel2(inputs)
	return de_signupquestionlabel2(inputs)
});
export { signupquestionlabel2 as "signupQuestionLabel" }